import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {

    constructor(private transloco: TranslocoService) {
        super();

        // React to language change
        this.transloco.langChanges$.subscribe(() => {
            this.setTranslations();
        });

        // Set initial translations
        this.setTranslations();
    }

    private setTranslations(): void {
        this.itemsPerPageLabel = this.transloco.translate('common.paginator.items-per-page');
        this.nextPageLabel = this.transloco.translate('common.paginator.next-page');
        this.previousPageLabel = this.transloco.translate('common.paginator.previous-page');
        this.firstPageLabel = this.transloco.translate('common.paginator.first-page');
        this.lastPageLabel = this.transloco.translate('common.paginator.last-page');

        this.changes.next();
    }

    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return this.transloco.translate('common.paginator.range-label-empty', { length });
        }

        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;

        return this.transloco.translate('common.paginator.range-label', {
            startIndex: startIndex + 1,
            endIndex,
            length
        });
    };
}
